import React, { ReactElement } from "react";
import { List, ListProps } from "react-admin";
import PoolPagination from "../PoolPaginationComponent/PoolPaginationComponent";
import { DefaultPerPageSize } from "../../Constants/Constant";

interface PoolListProps extends ListProps {
  children: ReactElement;
}

export const PoolList = ({
  perPage = DefaultPerPageSize,
  sort = { field: "id", order: "DESC" },
  pagination = <PoolPagination />,
  children,
  ...props
}: PoolListProps) => {
  return (
    <List perPage={perPage} sort={sort} pagination={pagination} {...props}>
      {children}
    </List>
  );
};
export default PoolList;
